import FO3 from './FO3';
import FO4 from './FO4';
import FO6 from './FO6';
import FO2 from './FO2';
import FO1 from './FO1';

export const riskTypes = {
  FO3,
  FO4,
  FO6Structures: FO6,
  FO2,
  FO1
};
